import { dashboardApi } from '@/api';
import { OptimisationBase } from '@/optimizer';

interface UpdateCampaignArgs {
    projectId: string;
    dashboardId: string;
    campaignId: string;
    startDate: string | undefined;
    endDate: string | undefined;
    budget: number | undefined;
    optimizationBase?: OptimisationBase;
    rules: {
        channel: string;
        type: string;
        value: number;
    }[];
    activeDaysPerMedium?: Record<string, number>;
}

export const updateCampaign = async ({
    projectId,
    dashboardId,
    campaignId,
    startDate = '',
    endDate = '',
    budget = 0,
    optimizationBase,
    rules = [],
    activeDaysPerMedium,
}: UpdateCampaignArgs) => {
    await dashboardApi({
        method: 'PATCH',
        url: `/customer-campaign/project/${projectId}/campaign/${campaignId}`,
        data: {
            startDate,
            endDate,
            budget,
            optimizationBase,
            rules,
            dashboardId,
            activeDaysPerMedium,
        },
    });
};
